<script setup>
import { provide, ref } from "vue";
import { __, getFormValuesFromLocalStorage } from '@/utils';
import Tabs from '@components/tabs.vue';

//Subscriber Form Fragments
import subscriberDetails from './fragments/subscriberFragments/details.vue';

//Company Form Fragments
import companyDetails from './fragments/companyFragments/details.vue';
import address from './fragments/address.vue';


import ShippingMethod from './fragments/shippingMethod.vue';
import ShippingAddress from './fragments/shippingAddress.vue';
import Notice from './fragments/notice.vue';
import Loader from '@components/loader.vue';

import nextStep from "@components/nextStep.vue";

const savedFields = getFormValuesFromLocalStorage();

const subscriberDisableExistingFields = ref(savedFields['subscriberDisableExistingFields'] ? savedFields['subscriberDisableExistingFields'] : false);
const companyDisableExistingFields = ref(savedFields['companyDisableExistingFields'] ? savedFields['companyDisableExistingFields'] : false);
const isExistingAccount = ref(savedFields['existingAccount'] ? savedFields['existingAccount'] : false );
const isPOAddress = ref(savedFields['subscriberAddressType'] ? savedFields['subscriberAddressType'] : false );
const showLoader = ref(false);

const tabs = [
	{
		title: __('Private Client'),
		body: [
				{ component: subscriberDetails, props: {} },
				{ component: address, props: { type: "subscriber", label: __("Entering the subscriber's address") } },
				{ component: ShippingAddress, props: {name:'subscriber', label:__('Subscriber address'), title:__('Home address is identical to shipping address')} },
				{ component: ShippingMethod, props: {name:'subscriber'} },
				{ component: Notice, props: {} }, 
		]
	},
	// {
	// 	title: __('Business Client'),
	// 	body: [
	// 			{ component: companyDetails, props: {} },
	// 			{ component: address, props: { type: "company", label: __('Enter the company address') } },
	// 			{ component: ShippingAddress, props: {name:'company', label:__('Company address'), title:__('The company address is the same as the shipping address')} },
	// 			{ component: ShippingMethod, props: {name:'company'} },
	// 			{ component: Notice, props: {} },
	// 	]
	// },
];

provide('step2', {
    subscriberDisableExistingFields,
    companyDisableExistingFields,
	isExistingAccount,
	isPOAddress,
	showLoader
});
</script>
<template>
	<div class="form__group">
		<header class="form__head">
			<h2>
				{{ __('Fill in details') }}
			</h2>
		</header><!-- /.form__head -->

		<div class="form__body">
			<Tabs :tabs="tabs" />
		</div><!-- /.form__body -->

		<nextStep v-if="!showLoader"/>
		<div class="form__actions" v-if="showLoader">
			<Loader color="#2563eb"/>
		</div>
	</div><!-- /.form__group -->
</template>
